export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => element => {
      let columns = rootGetters['rowModule/elements'](element).columns
      return Object.prototype.hasOwnProperty.call(element, 'column') ? columns[element.column] : columns
    },
    index: (state, getters) => (element, id) =>  getters.elements(element).findIndex(column => column.id == id),
    id: (state, getters) => element =>  getters.elements(element).id,
    name: (state, getters) => element => getters.elements(element).name,
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    assets: (state, getters) => element => getters.elements(element).assets,
    background: (state, getters) => element => getters.elements(element).background,
    properties: (state, getters) => element => getters.elements(element).properties,
  },

  actions: {
        updateOrder({commit}, payload) {
            payload = {...payload, module: 'columnModule'}
            commit('actionsModule/updateElementsOrder', payload, {root: true})
        },
        addToArray({commit}, payload) {
            payload = {...payload, module: 'columnModule'}
            commit('actionsModule/addToArray', payload, {root: true})
        },
        removeFromArray({commit}, payload) {
            payload = {...payload, module: 'columnModule'}
            commit('actionsModule/removeFromArray', payload, {root: true})
        },
        addToObject({commit}, payload) {
            payload = {...payload, module: 'columnModule'}
            commit('actionsModule/addToObject', payload, {root: true})
        },
  }
}